import React, { useState } from 'react';
import './BookingsList.css';
import InvoiceDownloadButton from './InvoiceDownloadButton';

const BookingsList = ({ bookings, statuses, onStatusUpdate, onEditBooking }) => {
  const [confirmDialog, setConfirmDialog] = useState(null);

  const getStatusColor = (statusName) => {
    switch (statusName) {
      case 'confirmed':
        return 'status-confirmed';
      case 'completed':
        return 'status-completed';
      case 'cancelled':
        return 'status-cancelled';
      default:
        return '';
    }
  };

  const formatCustomerName = (customer) => {
    return `${customer.first_name} ${customer.last_name}`;
  };

  const getStatusDescription = (statusId) => {
    const status = statuses.find(s => s.id === parseInt(statusId));
    return status ? status.description : '';
  };

  const handleStatusChange = (booking, newStatusId) => {
    if (!newStatusId || newStatusId === String(booking.status.id)) {
      return;
    }

    setConfirmDialog({
      bookingId: booking.id,
      newStatusId: parseInt(newStatusId),
      customerName: formatCustomerName(booking.customer),
      timeSlot: booking.time_slot,
      oldStatus: booking.status.description,
      newStatus: getStatusDescription(newStatusId)
    });
  };

  const confirmStatusChange = () => {
    if (confirmDialog && onStatusUpdate) {
      onStatusUpdate(confirmDialog.bookingId, confirmDialog.newStatusId);
    }
    setConfirmDialog(null);
  };

  const cancelStatusChange = () => {
    setConfirmDialog(null);
    // Reset the select element to its original value
    const selectElement = document.querySelector(`select[data-booking-id="${confirmDialog.bookingId}"]`);
    if (selectElement) {
      const booking = bookings.find(b => b.id === confirmDialog.bookingId);
      if (booking) {
        selectElement.value = booking.status.id;
      }
    }
  };

  if (bookings.length === 0) {
    return (
      <div className="no-bookings">
        <p>Keine Buchungen für die ausgewählten Filter gefunden.</p>
      </div>
    );
  }

  return (
    <div className="bookings-list">
      <table className="bookings-table">
        <thead>
          <tr>
            <th>Zeit</th>
            <th>Anlage</th>
            <th>Kunde</th>
            <th>Telefon</th>
            <th>Menge</th>
            <th>Status</th>
            <th>Rabatt</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {bookings.map(booking => (
            <tr key={booking.id} className={getStatusColor(booking.status.name)}>
              <td>{booking.time_slot}</td>
              <td>{booking.facility.name}</td>
              <td>{formatCustomerName(booking.customer)}</td>
              <td>
                {booking.customer.phone ? (
                  <a href={`tel:${booking.customer.phone}`} className="phone-link">
                    {booking.customer.phone}
                  </a>
                ) : (
                  '-'
                )}
              </td>
              <td>{booking.quantity} {booking.unit}</td>
              <td>
                <span className={`status-badge ${getStatusColor(booking.status.name)}`}>
                  {booking.status.description || booking.status.name}
                </span>
              </td>
              <td>
                {booking.discount_percent
                  ? `${booking.discount_percent}%`
                  : '-'}
              </td>
              <td className="actions-cell">
                <button
                  className="edit-button"
                  onClick={() => onEditBooking && onEditBooking(booking)}
                  title="Buchung bearbeiten"
                >
                  ✏️
                </button>
                <InvoiceDownloadButton
                  invoice={booking.invoice}
                  className="download-button"
                />
                <select
                  value={booking.status.id}
                  onChange={(e) => handleStatusChange(booking, e.target.value)}
                  className="status-select"
                  data-booking-id={booking.id}
                >
                  {statuses.map(status => (
                    <option key={status.id} value={status.id}>
                      {status.description || status.name}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {confirmDialog && (
        <div className="confirm-dialog-overlay">
          <div className="confirm-dialog">
            <h3>Status ändern bestätigen</h3>
            <p>
              Möchten Sie den Status für die Buchung von <strong>{confirmDialog.customerName}</strong> ({confirmDialog.timeSlot})
              wirklich von <strong>{confirmDialog.oldStatus}</strong> auf <strong>{confirmDialog.newStatus}</strong> ändern?
            </p>
            <div className="dialog-buttons">
              <button onClick={confirmStatusChange} className="confirm-button">
                Ja, Status ändern
              </button>
              <button onClick={cancelStatusChange} className="cancel-button">
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingsList;